import { BiArrowBack, BiBook, BiError } from "react-icons/bi";
import { capitalizeFirstLetter, parseInvestorTypeSimple } from "../../utils";
import { useHistory } from "react-router-dom";
import { RiUser3Line } from "react-icons/ri";
import { FiSettings } from "react-icons/fi";
import { AiOutlinePoweroff } from "react-icons/ai";
import React, { useState } from "react";
import useProfilePicture from "../../hooks/useProfilePicture";
import { useCustomer } from "../../hooks/useCustomer";
import { BsCreditCard2Front } from "react-icons/bs";
import { Spinner } from "react-bootstrap";
import useAuth from "../../hooks/useAuth";
import { RxUpdate } from "react-icons/rx";
import useSubscription from "../../hooks/useSubscription";
import { LuRocket } from "react-icons/lu";
import { IoWalletOutline } from "react-icons/io5";

const HeaderProfile = ({ userData }) => {
  const history = useHistory();
  const { getProfilePictureURI } = useProfilePicture();
  const { generateBillingPortalUrl } = useCustomer();
  const [isLoadingBilling, setIsLoadingBilling] = useState(false);
  const { destroySession } = useAuth();
  const [isPremium, setIsPremium] = useState(false);
  const { isUserPremiumUncached } = useSubscription();

  async function handleBillingManager() {
    setIsLoadingBilling(true);
    const responseBillingUrl = await generateBillingPortalUrl();

    if (responseBillingUrl) {
      window.location.replace(responseBillingUrl);
    }

    setIsLoadingBilling(false);
  }

  async function handleImageClick() {
    isUserPremiumUncached().then((res) => setIsPremium(res));
  }

  return (
    <div className="dropdown az-profile-menu">
      <a href="#/" className="az-img-user" onClick={() => handleImageClick()}>
        {userData && (
          <img
            src={getProfilePictureURI(userData.profile_picture)}
            alt="User"
          />
        )}
      </a>
      <div className="dropdown-menu">
        <div className="az-dropdown-header d-sm-none">
          <a href="#/" className="az-header-arrow">
            <i>{<BiArrowBack />}</i>
          </a>
        </div>
        <div className="az-header-profile">
          <div className="az-img-user">
            {userData && (
              <img
                src={getProfilePictureURI(userData.profile_picture)}
                alt="User"
              />
            )}
          </div>
          <h6 className="text-center">
            {userData && capitalizeFirstLetter(userData.name.substring(0, 24))}
          </h6>
          <span className="tx-medium mg-t-10">
            {(userData && userData.investor_type) ||
            (userData && userData.investor_type === 0)
              ? "Perfil: " + parseInvestorTypeSimple(userData.investor_type)
              : null}
          </span>
        </div>
        <span
          onClick={() => {
            history.push("/user-profile");
          }}
          className="dropdown-item hideOnClick cursor-pointer"
        >
          <i>{<RiUser3Line size={17} />}</i>
          Meu Perfil
        </span>
        <span
          onClick={() => {
            history.push("/account-settings");
          }}
          className="dropdown-item hideOnClick cursor-pointer"
        >
          <i>{<FiSettings size={17} />}</i>
          Configurações
        </span>

        {isPremium ? (
          <>
            <span
              onClick={() => {
                history.push("/plan-update");
              }}
              className="dropdown-item hideOnClick cursor-pointer"
            >
              <i>{<RxUpdate size={17} />}</i>
              Atualizar plano
            </span>

            <span
              onClick={(e) => {
                e.preventDefault();

                return handleBillingManager();
              }}
              className="dropdown-item cursor-pointer no-clicable-action"
            >
              <i>{<BsCreditCard2Front size={17} />}</i>
              {isLoadingBilling ? (
                <Spinner animation="border" size="sm" />
              ) : (
                "Gerenciar assinatura"
              )}
            </span>
          </>
        ) : (
          <>
            <span
              onClick={() => {
                history.push("/billing");
              }}
              className="dropdown-item hideOnClick cursor-pointer"
            >
              <i>{<LuRocket size={17} />}</i>
              Seja Premium
            </span>
          </>
        )}

        <span
          onClick={() => {
            history.push("/how-to-use");
          }}
          className="dropdown-item hideOnClick cursor-pointer"
        >
          <i>{<BiBook size={17} />}</i>
          Como usar a plataforma
        </span>

        <span
          onClick={() => {
            history.push("/bug-report");
          }}
          className="dropdown-item hideOnClick cursor-pointer"
        >
          <i>{<BiError size={17} />}</i>
          Reportar um problema
        </span>

        <span
          style={{ cursor: "pointer" }}
          onClick={() => destroySession()}
          className="dropdown-item"
        >
          <i>{<AiOutlinePoweroff size={17} />}</i>
          Sair
        </span>
      </div>
    </div>
  );
};

export const HeaderProfileMemo = React.memo(HeaderProfile);
